/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { httpRequest } from '../shared/http';
import { sanitize } from '../shared/utils/objectUtils';

const baseUrl = '/addressbook-api';
const partiesUrl = `${baseUrl}/parties`;
const importUrl = `${baseUrl}/imports`;
const duplicatesUrl = `${baseUrl}/duplicates`;

export default {
  createImport: async (file, options) => {
    const formData = new FormData();
    formData.append('file', file);
    const { data: resp } = await httpRequest(importUrl, {
      method: 'POST',
      data: formData,
      headers: {
        'Content-Type': 'multipart/mixed',
      },
      ...options,
    })();
    return sanitize(resp);
  },
  updateImport: async (importId, importData, options) => {
    const { data: resp } = await httpRequest(`${importUrl}/${importId}`, {
      method: 'PUT',
      data: importData,
      ...options,
    })();
    return sanitize(resp);
  },
  getImportByStatusAndUser: async (status, page = 0, size = 10, options) => {
    const { data: resp } = await httpRequest(`${importUrl}`, {
      method: 'GET',
      params: { status, page, size },
      ...options,
    })();
    return sanitize(resp);
  },
  getImportDuplicates: async (importId, page = 0, size = 10, options) => {
    const { data: resp } = await httpRequest(`${duplicatesUrl}`, {
      method: 'GET',
      params: { importId, page, size },
      ...options,
    })();
    return sanitize(resp);
  },
  getPartyDuplicates: async (partyId, page = 0, size = 10, options) => {
    const { data: resp } = await httpRequest(`${duplicatesUrl}`, {
      method: 'GET',
      params: { partyId, page, size },
      ...options,
    })();
    return sanitize(resp);
  },
  resolveImportDuplicates: async (importId, resolvedDuplicates, page = 0, size = 10, options) => {
    const { data: resp } = await httpRequest(`${duplicatesUrl}/imports/${importId}/duplicates`, {
      method: 'PUT',
      data: resolvedDuplicates,
      params: { page, size },
      ...options,
    })();
    return sanitize(resp);
  },
  resolvePartyDuplicates: async (partyId, resolvedDuplicate, page = 0, size = 10, options) => {
    const { data: resp } = await httpRequest(`${duplicatesUrl}/parties/${partyId}/duplicates`, {
      method: 'PUT',
      data: resolvedDuplicate,
      params: { page, size },
      ...options,
    })();
    return sanitize(resp);
  },
  get: async (id, options) => {
    const { data: resp } = await httpRequest(`${partiesUrl}/${id}`, {
      method: 'GET',
      ...options,
    })();
    return sanitize(resp);
  },
  create: async (contact, options) => {
    const { data: resp } = await httpRequest(partiesUrl, {
      method: 'POST',
      data: sanitize(contact),
      ...options,
    })();
    return sanitize(resp);
  },
  update: async (contact, id, options) => {
    const { data: resp } = await httpRequest(`${partiesUrl}/${id}`, {
      method: 'PUT',
      data: sanitize(contact),
      ...options,
    })();
    return sanitize(resp);
  },
  paginate: async (page, size, sort, options) => {
    const { sortColumn: column, sortOrder: order } = sort;
    const direction = order === 'DSC' ? 'DESC' : order;

    const { data: resp } = await httpRequest(`${partiesUrl}`, {
      method: 'GET',
      params: { page: Math.max(0, page) || 0, size, column, direction },
      ...options,
    })();
    return resp;
  },
  deleteContacts: async (contactsId, options) => {
    const { data: resp } = await httpRequest(`${partiesUrl}`, {
      method: 'DELETE',
      data: contactsId,
      ...options,
    })();
    return resp;
  },
};
